import Vue from 'vue'
import './plugins/firebase'
import 'firebase/auth';
import VueQuillEditor from 'vue-quill-editor'
import ImageCompress from "quill-image-compress";
import VueCountdownTimer from 'vuejs-countdown-timer';
import App from './App.vue'
import store from "./store";
import router from './router';
import Vuelidate from "vuelidate";
import vuetify from './plugins/vuetify';
import axios from './plugins/axios'
import VueAxios from 'vue-axios'
import VueDateFns from "vue-date-fns";
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import snackbarPlugin from './plugins/snackbar'
import './registerServiceWorker'
import {i18n} from './plugins/i18n'
import {firestorePlugin} from "vuefire";
import './sentry';
import moment from 'moment';
import VueMoment from 'vue-moment';
import ToggleButton from 'vue-js-toggle-button'
import Typewriter from 'vue-typewriter'
import VueParticles from 'vue-particles'
import VueTextTransition from "vue-text-transition";
import LottieAnimation from 'lottie-web-vue'
import VueRx from 'vue-rx'
import VuejsClipper from "vuejs-clipper";
import VueYouTubeEmbed from 'vue-youtube-embed'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueClipboard from 'vue-clipboard2'
import VueVideoPlayer from 'vue-video-player'
import AsyncComputed from 'vue-async-computed'
import InfiniteLoading from 'vue-infinite-loading';
import 'video.js/dist/video-js.css'


Vue.use(InfiniteLoading, { /* options */ });
Vue.use(VueYouTubeEmbed, { global: true, componentId: "youtube-media" })
Vue.use(VueRx);
Vue.use(VuejsClipper);
Vue.config.productionTip = process.env.VUE_APP_ENVIRONMENT === 'production'
Vue.use(Vuelidate);
Vue.use(ToggleButton) // TODO remove this package if its not being used anymore
Vue.use(VueQuillEditor, {
    modules: [
        {
            name: "ImageCompress",
            module: ImageCompress,
            options: {
                quality: 1,
                debug: true, // default
                suppressErrorLogging: false, // default
                insertIntoEditor: undefined, // default
                ignoreImageTypes:  ['image/jpeg', 'image/png']
            },
        }]
})
Vue.use(VueDateFns);
Vue.use(snackbarPlugin, {store})
Vue.use(VueAxios, axios)
Vue.use(firestorePlugin)
Vue.use(VueCountdownTimer);
Vue.use(VueTelInputVuetify, {vuetify,})
Vue.use(Typewriter)
Vue.use(VueParticles)
Vue.use(LottieAnimation)
Vue.use(vueVimeoPlayer)
Vue.component('vue-text-transition', VueTextTransition)
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(VueVideoPlayer)
Vue.use(AsyncComputed)
Vue.use(VueVideoPlayer, /* {
    options: global default options,
    events: global videojs events
  } */)

require('moment/locale/en-gb');
moment.locale('en-gb');
Vue.use(VueMoment, {moment});
new Vue({
    render: h => h(App),
    router,
    store,
    vuetify,
    i18n
}).$mount('#app')
